import { dataEntryService } from "../services/data-entry.services";
import { overviewStore } from "../stores/overview.store";
import { dataEntryFiltersStore } from "../stores/data-entry-filters.store";

// Monotonic call id. Each loadOverview call captures its own id and only
// commits results / clears loading if it's still the latest in flight —
// otherwise a slow earlier request would overwrite a newer one's results.
let overviewCallId = 0;

export const loadOverview = async () => {
  const myId = ++overviewCallId;
  const { page, pageSize, sort } = overviewStore;
  const sharedF = dataEntryFiltersStore.filters;
  overviewStore.setLoading(true);

  try {
    const params = {
      page,
      limit: pageSize,
      sortField: sort.key,
      sortOrder: sort.direction,
    };

    if (sharedF.year) params.reportingYear = sharedF.year;
    if (sharedF.framework) params.framework = sharedF.framework;
    if (sharedF.category) params.category = sharedF.category;
    if (sharedF.metricType) params.source = sharedF.metricType;
    if (sharedF.search) params.search = sharedF.search;
    if (sharedF.orgIds?.length) params.orgIds = sharedF.orgIds.join(",");

    const data = await dataEntryService.listOverview(params);
    if (myId !== overviewCallId) return;
    const items = Array.isArray(data?.items) ? data.items : [];
    const meta = data?.meta || {};

    console.log("data in overview ops,", items, meta);

    overviewStore.setItems(
      items,
      Number.isFinite(meta.total) ? meta.total : items.length,
    );
  } catch {
    if (myId !== overviewCallId) return;
    overviewStore.setItems([], 0);
  } finally {
    if (myId === overviewCallId) overviewStore.setLoading(false);
  }
};
